import emptyReducer from './emptyReducer';

const toDocumentsApproved = (...docs: string[]) =>
  emptyReducer<boolean>(false).with({
    DocumentsApproval: (_, documents) => docs.every(doc => doc in documents),
  });

export default toDocumentsApproved;
